// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"styles_wrapper__2Ltxj","header":"styles_header__BL2ky","contentWrapper":"styles_contentWrapper__FWp8K","open":"styles_open__Cw_ix","content":"styles_content__w4FiY"};